import React, { lazy } from "react";

// project-imports
import Loadable from "components/Loadable";
import { commonRoutesConstants, routeConstants } from "services/keyConstants";
import CreateInstallationFormat from "../CreateInstallationFormat";
import CommonYearList from "components/reusables/CommonYearList";
import { getData } from "./service";
import * as url from "./UrlHelper";

// render - pages
const ReportList = Loadable(lazy(() => import("../ReportList")));
const ReportDetails = Loadable(lazy(() => import("../ReportDetails")));
const ProductReportList = Loadable(lazy(() => import("../ProductReportList")));
const InstallationChecklist = Loadable(
  lazy(() => import("../InstallationChecklist"))
);
const List = Loadable(lazy(() => import("../List")));
const YearList = Loadable(lazy(() => import("../YearList")));
const NotifyForInstallationHead = Loadable(
  lazy(() => import("../NotifyForInstallationHead"))
);
const InstallationChildFormats = Loadable(
  lazy(() => import("../InstallationChildFormats"))
);
const InstallationFormat = Loadable(
  lazy(() => import("../InstallationFormat"))
);
const InstallationReport = Loadable(
  lazy(() => import("../InstallationReport"))
);

// ==============================|| AUTH ROUTES ||============================== //

const InstallationRoutes = [
  {
    path: routeConstants.INSTALLATION,
    children: [
      { path: "installation-checklist", element: <InstallationChecklist /> },
      {
        path: "notification-for-installation-head",
        element: <NotifyForInstallationHead />,
      },
      { path: "installation-format/:year", element: <InstallationFormat /> },
      {
        path: "installation-childFormats",
        element: <InstallationChildFormats />,
      },
      { path: "installation-report", element: <InstallationReport /> },
      {
        path: commonRoutesConstants.YEAR_LIST,
        element: (
          <CommonYearList
            uri={url.GET_BY_YEAR}
            title={routeConstants.INSTALLATION}
            isRenderComponent={() =>
              React.createElement(CreateInstallationFormat, { getData })
            }
            navigateToFolder={`/${routeConstants.INSTALLATION}/installation-format/`}
          />
        ),
      },
      // { path: "device-list", element: <DeviceList /> },
      { path: "report-list", element: <ReportList /> },
      // { path: "report-list/:id", element: <ProductReportList /> },
      { path: "list/:id/:productId", element: <List /> },
      { path: "report/:id", element: <ReportDetails /> },
    ],
  },
];

export default InstallationRoutes;
